import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken';
import {
    SET_ACTIVE_FIRM,
    LOAD_ACTIVE_FIRM,
    CLEAR_ACTIVE_FIRM,
    LOAD_USER_FIRMS,
    USER_FIRMS_LOADING,
    USER_FIRMS_ERROR
} from './types';

const ACTIVE_FIRM_STORAGE_KEY = 'activeFirm';

// Load active firm from localStorage
export const loadActiveFirm = () => (dispatch) => {
    try {
        const storedFirm = localStorage.getItem(ACTIVE_FIRM_STORAGE_KEY);
        if (storedFirm) {
            const activeFirm = JSON.parse(storedFirm);
            dispatch({
                type: LOAD_ACTIVE_FIRM,
                payload: activeFirm
            });
        }
    } catch (err) {
        console.error('Error loading active firm from localStorage:', err);
        localStorage.removeItem(ACTIVE_FIRM_STORAGE_KEY);
    }
};

// Set active firm and persist to localStorage
export const setActiveFirm = (firm) => (dispatch) => {
    try {
        if (firm) {
            // Store essential firm data
            const firmData = {
                id: firm.id,
                name: firm.name,
                address: firm.address || null
            };
            localStorage.setItem(ACTIVE_FIRM_STORAGE_KEY, JSON.stringify(firmData));
            dispatch({
                type: SET_ACTIVE_FIRM,
                payload: firmData
            });
        } else {
            localStorage.removeItem(ACTIVE_FIRM_STORAGE_KEY);
            dispatch({
                type: CLEAR_ACTIVE_FIRM
            });
        }
    } catch (err) {
        console.error('Error setting active firm:', err);
        dispatch(setAlert('Firmani tanlashda xatolik', 'danger'));
    }
};

// Clear active firm
export const clearActiveFirm = () => (dispatch) => {
    localStorage.removeItem(ACTIVE_FIRM_STORAGE_KEY);
    dispatch({
        type: CLEAR_ACTIVE_FIRM
    });
};

// Load user's available firms
export const loadUserFirms = () => async (dispatch) => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    
    try {
        dispatch({ type: USER_FIRMS_LOADING });
        
        const res = await axios.get('/firms/manager-options');
        
        dispatch({
            type: LOAD_USER_FIRMS,
            payload: res.data || []
        });
        
        return res.data || [];
    } catch (err) {
        dispatch({
            type: USER_FIRMS_ERROR,
            payload: err?.response?.data?.message || 'Firmalarni yuklashda xatolik'
        });
        return [];
    }
};

// Auto-select first firm if none selected
export const autoSelectFirstFirm = () => async (dispatch, getState) => {
    const { activeFirm } = getState().firm;
    
    // If already has active firm, skip
    if (activeFirm?.id) {
        return;
    }
    
    // Load firms and select first one
    const firms = await dispatch(loadUserFirms());
    
    if (firms && firms.length > 0) {
        dispatch(setActiveFirm(firms[0]));
    }
};

// Validate active firm is still accessible
export const validateActiveFirm = () => async (dispatch, getState) => {
    const { activeFirm, userFirms } = getState().firm;
    
    if (!activeFirm?.id) {
        return;
    }
    
    // Check if active firm is in user's available firms
    const firmStillValid = userFirms.some(f => f.id === activeFirm.id);
    
    if (!firmStillValid && userFirms.length > 0) {
        // Active firm no longer accessible, switch to first available
        dispatch(setActiveFirm(userFirms[0]));
        dispatch(setAlert('Oldingi firma mavjud emas, boshqa firmaga o\'tildi', 'warning'));
    } else if (!firmStillValid && userFirms.length === 0) {
        // No firms available
        dispatch(clearActiveFirm());
    }
};
